// extracted by mini-css-extract-plugin
export default {"PatientInfoPop":"DoctorInfoPop_PatientInfoPop__3U3Ze","header":"DoctorInfoPop_header__-ZoRh"};